import script from "./SelectProductComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectProductComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SelectProductComponent.vue?vue&type=style&index=0&id=9c07cac0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c07cac0"]])

export default __exports__